module.exports = __webpack_public_path__ + "img/nkbtntp.db98b507.png";